module.exports = __webpack_public_path__ + "images/ernstyoung07d1185398ad64abf5069f70eb88e99d.png";